module.exports = __webpack_public_path__ + "static/img/text-bg.35ad165.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/researchSystem/images/text-bg.png
// module id = U0Av
// module chunks = 0